import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import UploadImage from "../UploadImage/UploadImage";
import { PatchApi, base_url, getApi } from "../../Utility/network";
import axios from "axios";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import { consumCertGerText } from "../../Utility/gerLangObject";
import { consumCertEngText } from "../../Utility/engLangObject";

export default function DialogAdd({
  openDialog,
  setOpenDialog,
  notes,
  setNotes,
}) {
  const { state } = React.useContext(AppContext);
  const [open, setOpen] = React.useState(false);
  const [image, setImage] = React.useState("");
  const [building, setBuilding] = React.useState([]);
  const { stepLanguage, language } = state;
  React.useEffect(() => {
    setOpen(openDialog);
  }, [openDialog]);

  const handleClose = () => {
    setOpenDialog(false);
  };

  React.useEffect(() => {
    if (image) {
      formDataImage(image);
    }
  }, [image]);
  React.useEffect(() => {
    getData();
  }, []);
  const formDataImage = (_image) => {
    const formData = new FormData();
    formData.append("files", _image);
    const axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    axios
      .patch(
        `${base_url}/energy_need/${state.needId}/upload_structure_detail_files/`,
        formData,
        axiosConfig
      )
      .then((response) => {
        setImage();
        setBuilding(response.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getData = async () => {
    try {
      const response = await getApi(`/energy_need/${state.needId}/`);
      const { structure_detail, structure_documents } = response.data.data;
      setNotes(structure_detail?.notes ? structure_detail?.notes : "");
      setBuilding(structure_documents);
    } catch (error) {}
  };
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            handleClose();
          },
        }}
      >
        <DialogTitle>
          <p
            style={{
              color: "#22A156",
              fontSize: "26px",
              lineHeight: "24px",
              textAlign: "center",
            }}
          >
            {language === "de"
              ? consumCertGerText.additional_document
              : consumCertEngText.additional_document}
          </p>
          <hr style={{ background: "#22A156" }} />
        </DialogTitle>{" "}
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                background: "#AFDB2840",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <p
                style={{
                  marginTop: "0px",
                  color: "black",
                  fontWeight: "600",
                  marginBottom: "8px",
                  lineHeight: "24px",
                }}
              >
                {" "}
                {language === "de"
                  ? consumCertGerText.document_additional_text
                  : consumCertEngText.document_additional_text}
              </p>
              <p style={{ lineHeight: "16px", marginTop: "8px" }}>
                {language === "de"
                  ? consumCertGerText.document_secondary_text
                  : consumCertEngText.document_secondary_text}
              </p>
            </div>
            <div>
              <p style={{ color: "black", fontWeight: "600" }}>
                {language === "de"
                  ? consumCertGerText.additional_document
                  : consumCertEngText.additional_document}
              </p>{" "}
              <UploadImage getImage={setImage} imgs={image} />
            </div>
          </DialogContentText>
          <div style={{ marginTop: "10px" }}>
            {building.map((item, index) => {
              const fileName = item.file.split("/").pop();
              return (
                <div
                  style={{
                    backgroundColor: "rgba(175, 219, 40, 0.15)",
                    display: "flex",
                    padding: "10px",
                    borderRadius: "8px",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <div>
                    <img src={item.file} style={{ width: "60px" }} />
                    <p>{fileName}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <div>
            <p style={{ color: "black", fontWeight: "600" }}>
              {language === "de"
                ? consumCertGerText.document_info
                : consumCertEngText.document_info}
            </p>
            <div>
              <TextField
                multiline
                maxRows={2}
                style={{ width: "100%" }}
                onChange={(e) => {
                  setNotes(e.target.value);
                }}
                value={notes}
              />
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Button
              onClick={() => setOpenDialog(false)}
              style={{ marginRight: "10px" }}
              variant="outlined"
              sx={{
                padding: "12px 25px",
                borderRadius: "10px",
                background: "white",
                // boxShadow: "none",
                // color: "white",
                // "&:disabled": {
                //   background: "gray",
                //   color: "#ccc",
                // },
                marginRight: "10px",
              }}
            >
              {language === "de"
                ? consumCertGerText.cancel
                : consumCertEngText.cancel}
            </Button>

            <Button
              onClick={() => setOpenDialog(false)}
              variant="contained"
              sx={{
                padding: "12px 25px",
                background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                boxShadow: "none",
                borderRadius: "10px",
                color: "white",
                "&:disabled": {
                  background: "gray",
                  color: "#ccc",
                },
              }}
            >
              {language === "de"
                ? consumCertGerText.submit_details
                : consumCertEngText.submit_details}
            </Button>
          </div>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
